import routerOptions0 from "/Users/szymondziak/StudioProjects/quoteiq-web-nuxt/node_modules/.pnpm/nuxt@3.15.4_@electric-sql+pglite@0.2.16_@parcel+watcher@2.5.1_@types+node@22.13.1_db0@0_38f217d6774600b51ae43b83fb621c1e/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}